import yup from '../../../config/yup';

export const printSchemaValidationSchema = yup.object().shape({
  '@id': yup.string().default(''),
  '@data-type': yup.string().default('command'),
  type: yup.string().default('printSchema'),
  action: yup.string().default('PRINT_SCHEMA').required('Action is required'),
  command: yup
    .string()
    .default('PRINT_SCHEMA')
    .required('Command is required')
    .matches(
      /^PRINT_SCHEMA\s+\S+/i,
      "Command must start with 'PRINT_SCHEMA' followed by at least one word"
    ),
});
